type IconName =
  | 'gem'
  | 'shield'
  | 'back'
  | 'refresh'
  | 'copy'
  | 'check'
  | 'close'
  | 'dice'
  | 'bolt'
  | 'gift'
  | 'rocket'
  | 'send'
  | 'chart'
  | 'user'
  | 'trophy';

interface Props {
  name: IconName;
  size?: number;
  className?: string;
}

// Лёгкие line-иконки в стиле stake. Никаких эмодзи.
export function Icon({ name, size = 20, className }: Props) {
  const stroke = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
  };

  switch (name) {
    case 'gem':
      // ромб/гем (TON), заливка
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
          <path d="M12 2l9 7.5L12 22 3 9.5 12 2z" opacity="0.95" />
        </svg>
      );
    case 'shield':
      return (
        <svg {...stroke}>
          <path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      );
    case 'back':
      return (
        <svg {...stroke}>
          <path d="M15 18l-6-6 6-6" />
        </svg>
      );
    case 'refresh':
      return (
        <svg {...stroke}>
          <path d="M21 12a9 9 0 1 1-2.64-6.36" />
          <path d="M21 3v5h-5" />
        </svg>
      );
    case 'copy':
      return (
        <svg {...stroke}>
          <rect x="9" y="9" width="11" height="11" rx="2" />
          <path d="M5 15V5a2 2 0 0 1 2-2h10" />
        </svg>
      );
    case 'check':
      return (
        <svg {...stroke}>
          <path d="M20 6L9 17l-5-5" />
        </svg>
      );
    case 'close':
      return (
        <svg {...stroke}>
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      );
    case 'bolt':
      return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
          <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
        </svg>
      );
    case 'dice':
      return (
        <svg {...stroke}>
          <rect x="3" y="3" width="18" height="18" rx="4" />
          <circle cx="8.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
          <circle cx="15.5" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
          <circle cx="15.5" cy="8.5" r="1.2" fill="currentColor" stroke="none" />
          <circle cx="8.5" cy="15.5" r="1.2" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'send':
      return (
        <svg {...stroke}>
          <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
        </svg>
      );
    case 'chart':
      return (
        <svg {...stroke}>
          <path d="M3 3v18h18" />
          <path d="M7 14l3-4 3 3 4-6" />
        </svg>
      );
    case 'user':
      return (
        <svg {...stroke}>
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c0-4 3.5-6 8-6s8 2 8 6" />
        </svg>
      );
    case 'trophy':
      return (
        <svg {...stroke}>
          <path d="M7 4h10v4a5 5 0 0 1-10 0V4z" />
          <path d="M7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3M9 18h6M10 14v4M14 14v4M8 21h8" />
        </svg>
      );
    case 'rocket':
      return (
        <svg {...stroke}>
          <path d="M5 15c-1 2-1 4-1 4s2 0 4-1M14.5 4.5C17 6 18 9 18 12l-4 4c-3 0-6-1-7.5-3.5L11 8z" />
          <path d="M9 11l4 4M15 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
        </svg>
      );
    case 'gift':
      return (
        <svg {...stroke}>
          <rect x="3" y="8" width="18" height="4" rx="1" />
          <path d="M5 12v9h14v-9M12 8v13" />
          <path d="M12 8S9 3 6.5 4.5 9 8 12 8zM12 8s3-5 5.5-3.5S15 8 12 8z" />
        </svg>
      );
    default:
      return null;
  }
}
